import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    // {
    //   path: "/",
    //   props: true,
    //   component: () => import("./layout/Default"),
    //   meta: {
    //     requiresAuth: true,
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "dashboard",
    //       meta: {
    //         requiresAuth: true,
    //       },
    //       component: () => import("./views/Dashboard/Dashboard"),
    //     },
    //     {
    //       path: "/add",
    //       name: "adds",
    //       meta: {
    //         requiresAuth: true,
    //       },
    //       component: () => import("./layout/Admins/addMenu"),
    //     },
    
    //  ],
    // },

    
        {
          path: "/",
          name: "landing",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Landing/Landing"),
        },
        {
          path: "/book-demo",
          name: "bookDemo",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Landing/BookDemo"),
        },
        {
          path: "/privacy-policy",
          name: "privacyPolicy",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Landing/PrivacyPolicy"),
        },
        {
          path: "/terms-conditions",
          name: "termsConditions",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Landing/TermsConditions"),
        },
        {
          path: "/login",
          name: "login",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Authentication/Login"),
        },
        {
          path: "/forgot-password",
          name: "forgotPassword",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Authentication/Login"),
        },
        {
          path: "/ForgotPassword",
          redirect: "/login?forgot=true",
        },
        {
          path: "/signup",
          name: "signup",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Authentication/Signup"),
        },
        {
          path: "/reset-password",
          name: "resetPassword",
          meta: {
            requiresAuth: true,
            isSuperAdmin: true,
            isJewellaryAdmin: true,
            isStaff: true,
          },
          component: () => import("./views/Authentication/ResetPassword"),
        },
        {
          path: "/add",
          name: "adds",
          meta: {
            requiresAuth: true,
          },
          component: () => import("./layout/Admins/addMenu"),
        },
        
        {
          path: "/dashboard",
          props: true,
          component: () => import("./layout/BaseLayout"),
          meta: {
            requiresAuth: true,
            isSuperAdmin: true,
            isJewellaryAdmin: true,
            isStaff: true,

          },
          children: [
            //SuperAdmin
            {
              path: "/superadminDashboard",
              name: "superadminDashboard",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,
              },
              component: () => import("./views/SuperAdmin/superadminDashboard"),
            },
            {
              path: "/ViewAdmin",
              name: "ViewAdmin",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,

              },
              component: () => import("./views/SuperAdmin/ViewAdmin"),
            },
            {
              path: "/PlatformAdmins",
              name: "PlatformAdmins",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,
              },
              component: () => import("./views/SuperAdmin/PlatformAdmins"),
            },
            {
              path: "/SuperAdminAuditLog",
              name: "SuperAdminAuditLog",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,
              },
              component: () => import("./views/SuperAdmin/SuperAdminAuditLog"),
            },
            {
              path: "/DemoRequests",
              name: "DemoRequests",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,
              },
              component: () => import("./views/SuperAdmin/DemoRequests"),
            },
            //add new menu&submenu
            {
              path: "/MenuMaster",
              name: "MenuMaster",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isJewellaryAdmin: false,
                isStaff: false,

              },
              component: () => import("./views/SuperAdmin/MenuMaster"),
            }, 
            //jewellary admin
            {
              path: "/JewelleryDashboard",
              name: "JewelleryDashboard",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,

              },
              component: () => import("./views/JewelAdmin/JewelleryDashboard"),
            },
            {
              path: "/userProfile",
              name: "userProfile",
              meta: {
                requiresAuth: true,
                 isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/userProfile"),
            },
            {
              path: "/BoardingRate",
              name: "BoardingRate",
              meta: {
                requiresAuth: true,
                 isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/BoardingRate"),
            },
            {
              path: "/rolesList",
              name: "rolesList",
              meta: {
                requiresAuth: true,
                 isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/rolesList"),
            },
            {
              path: "/AuditLog",
              name: "AuditLog",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/AuditLog"),
            },
            {
              path: "/CustomerStatement",
              name: "CustomerStatement",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/CustomerStatement"),
            },
            {
              path: "/StockValuation",
              name: "StockValuation",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/StockValuation"),
            },
            {
              path: "/ScanItem",
              name: "ScanItem",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/ScanItem"),
            },
            {
              path: "/KarigarManagement",
              name: "KarigarManagement",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/KarigarManagement"),
            },
            {
              path: "/KarigarJobs",
              name: "KarigarJobs",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/KarigarJobs"),
            },
            {
              path: "/RepairJobs",
              name: "RepairJobs",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/RepairJobs"),
            },
            {
              path: "/DiscountApprovals",
              name: "DiscountApprovals",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/DiscountApprovals"),
            },
            {
              path: "/AccountHeads",
              name: "AccountHeads",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/Accounts/AccountHeads"),
            },
            {
              path: "/Accounts",
              name: "Accounts",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/Accounts/Accounts"),
            },
            {
              path: "/TrialBalance",
              name: "TrialBalance",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/Accounts/TrialBalance"),
            },
            {
              path: "/ProfitAndLoss",
              name: "ProfitAndLoss",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/Accounts/ProfitAndLoss"),
            },
            {
              path: "/BalanceSheet",
              name: "BalanceSheet",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/Accounts/BalanceSheet"),
            },
            {
              path: "/Staff",
              name: "StaffManagement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/StaffManagement"),
            },
            {
              path: "/Supplier",
              name: "SupplierManagement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Supplier/SupplierManagement"),
            },
            {
              path: "/SupplierDetail",
              name: "SupplierDetail",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Supplier/SupplierDetail"),
            },
            {
              path: "/supplierSettlement",
              name: "supplierSettlement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Supplier/supplierSettlement"),
            },
            {
              path: "/settledList",
              name: "settledList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/settledList"),
            },
            {
              path: "/purchaseDetails",
              name: "purchaseItemDetails",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/purchaseItemDetails"),
            },
            {
              path: "/Customer",
              name: "CustomerManagement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/CustomerManagement"),
            },
            {
              path: "/Category",
              name: "testpage3",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/testpage3"),
            },
            // {
            //   path: "/CategoryManagementOld",
            //   name: "CategoryManagement",
            //   meta: {
            //     requiresAuth: true,
            //       isSuperAdmin: false,
            //     isJewellaryAdmin: true,
            //     isStaff: true,
            //   },
            //   component: () => import("./views/JewelAdmin/CategoryManagement"),
            // },
            // {
            //   path: "/CategoryItem",
            //   name: "CategoryItem",
            //   meta: {
            //     requiresAuth: true,
            //       isSuperAdmin: false,
            //     isJewellaryAdmin: true,
            //     isStaff: true,
            //   },
            //   component: () => import("./views/JewelAdmin/CategoryItem"),
            // },
            // {
            //   path: "/Design",
            //   name: "ItemDesignManagement",
            //   meta: {
            //     requiresAuth: true,
            //       isSuperAdmin: false,
            //     isJewellaryAdmin: true,
            //     isStaff: true,
            //   },
            //   component: () => import("./views/JewelAdmin/ItemDesignManagement"),
            // },
            {
              path: "/hsnCode",
              name: "hsnCode",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/hsnCode"),
            },
            {
              path: "/Purchase",
              name: "Purchase",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/Purchase"),
            },
            {
              path: "/PurchaseSettlement2",
              name: "PurchaseSettlement2",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/PurchaseSettlement2"),
            },
            {
              path: "/PurchaseSettlement",
              name: "PurchaseSettlement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/PurchaseSettlement"),
            },
            {
              path: "/PurchaseList",
              name: "PurchaseList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/PurchaseList"),
            },
            {
              path: "/IssueReceipt",
              name: "IssueReceipt",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/IssueReceipt"),
            },
            {
              path: "/IssueReceiptList",
              name: "IssueReceiptList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/IssueReceiptList"),
            },
            {
              path: "/Conversion",
              name: "Conversion",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/Conversion"),
            },
            {
              path: "/ConversionList",
              name: "ConversionList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/Purchase/ConversionList"),
            },

            {
              path: "/MenuManagement",
              name: "MenuManagement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/MenuManagement"),
            },
            {
              path: "/StockPage",
              name: "StockPage",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/JewelAdmin/StockPage"),
            },
            {
              path: "/GoldSchemeold",
              name: "GoldScheme",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldScheme"),
            },
            {
              path: "/GoldSchemeView",
              name: "GoldSchemeView",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldSchemeView"),
            },
            {
              path: "/GoldSchemeCreation",
              name: "GoldSchemeCreation",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldSchemeCreation"),
            },
            {
              path: "/GoldSchemeEnlisting",
              name: "GoldSchemeEnlisting",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldSchemeEnlisting"),
            },
            {
              path: "/GoldSchemelist",
              name: "GoldSchemelist",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldSchemelist"),
            },
            {
              path: "/AcidingList",
              name: "AcidifyingHome",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/Acidifying/AcidifyingHome"),
            },
            {
              path: "/AcidingReport",
              name: "AcidingReport",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/Acidifying/AcidingReport"),
            },
            {
              path: "/OldGoldStatement",
              name: "OldGoldStatement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Acidifying/OldGoldStatement"),
            },
            {
              path: "/AcidingPage",
              name: "AcidingPage",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/AcidingPage"),
            },
            {
              path: "/AcidingConfirm",
              name: "AcidingConfirm",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/AcidingConfirm"),
            },
            {
              path: "/AcidingAfter",
              name: "AcidingAfter",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/AcidingAfter"),
            },
            {
              path: "/oldGoldList",
              name: "oldGoldList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/OldGold/oldGoldList"),
            },
            {
              path: "/returnGoldList",
              name: "returnGoldList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                 isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/JewelAdmin/ReturnGold/returnGoldList"),
            },
            
            //StaffDashboard
            {
              path: "/StaffDashboard",
              name: "StaffDashboard",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: false,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/StaffDashboard"),
            },
            {
              path: "/billDetail",
              name: "billDetail",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/billDetail"),
            },
            {
              path: "/sales",
              name: "sales",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/sales"),
            },
            {
              path: "/SalesList",
              name: "SalesList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/SalesList"),
            },
            {
              path: "/SalesPage1",
              name: "SalesPage1",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/SalesPage1"),
            },
            {
              path: "/SalesSettlement",
              name: "SalesSettlement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/SalesSettlement"),
            },
            {
              path: "/SalesSettlementEdit",
              name: "SalesSettlementEdit",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/SalesSettlementEdit"),
            },
            {
              path: "/salesReport",
              name: "salesReport",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/salesReport"),
            },
            {
              path: "/DailySummary",
              name: "DailySummary",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/DailySummary"),
            },
            {
              path: "/StockSummary",
              name: "StockSummary",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Sales/StockSummary"),
            },
            {
              path: "/DailySalesReport",
              name: "DailySalesReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/DailySalesReport"),
            },
            {
              path: "/DailyIssueReceiptReport",
              name: "DailyIssueReceiptReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/DailyIssueReceiptReport"),
            },
            {
              path: "/DailyStockReport",
              name: "DailyStockReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/DailyStockReport"),
            },
            {
              path: "/AccountingVouchersReport",
              name: "AccountingVouchersReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: false,
              },
              component: () => import("./views/StaffAdmin/Reports/AccountingVouchersReport"),
            },
            {
              path: "/AdvancesReport",
              name: "AdvancesReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/AdvancesReport"),
            },
            {
              path: "/CreditorsReport",
              name: "CreditorsReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/CreditorsReport"),
            },
            {
              path: "/SupplierWiseReport",
              name: "SupplierWiseReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/SupplierWiseReport"),
            },
            {
              path: "/SalesmanWiseReport",
              name: "SalesmanWiseReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/SalesmanWiseReport"),
            },
            {
              path: "/GoldSchemeReport",
              name: "GoldSchemeReport",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Reports/GoldSchemeReport"),
            },
            {
              path: "/EstimatePage",
              name: "EstimatePage",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/Estimate/EstimatePage"),
            },
            {
              path: "/EstimatePage2",
              name: "EstimatePage2",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/EstimatePage2"),
            },
            {
              path: "/SalesPage2",
              name: "SalesPage2",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/SalesPage2"),
            },
            {
              path: "/GoldScheme",
              name: "GoldSchemeList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldScheme/GoldSchemeList"),
            },
            {
              path: "/CustomerSchemeList",
              name: "CustomerSchemeList",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldScheme/CustomerSchemeList"),
            },
            // 
            {
              path: "/CustomerDetail",
              name: "CustomerDetail",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldScheme/CustomerDetail"),
            },
            {
              path: "/GoldSchemePayment",
              name: "GoldSchemePayment",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                isJewellaryAdmin: true,
                isStaff: true,
              },
              component: () => import("./views/StaffAdmin/GoldScheme/GoldSchemePayment"),
            },
          ],
        },
        
        {
          path: "/paymentTest",
          name: "paymentTest",
          props: true,
          component: () => import("./backup/paymentTest"),
          meta: {
            requiresAuth: true,
          },
        },
    {
      path: "/servererror",
      name: "servererror",
      props: true,
      component: () => import("./common/500"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/500",
      name: "500",
      props: true,
      component: () => import("./common/500"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "*",
      name: "404pagenotfound",
      props: true,
      component: () => import("./common/404"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
  scrollBehavior() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },
});
router.beforeEach(async (to, from, next) => {
  localStorage.setItem("PRE", from.path);

  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth == true);

  if (requiresAuth) {
    const token = localStorage.getItem("token");

    if (!token) {
      next({ name: "login", params: { lastPage: from } });
      return;
    }

    try {
      const response = await axios({
        method: "POST",
        url: "/validate/token",
        headers: {
          "x-auth-token": token,
        },
      });

      if (!response.data.status) {
        // Clear the invalid session without store.commit("logoutUser") --
        // that mutation also calls router.push("/") itself, which would race
        // with the next() redirect below.
        localStorage.clear();
        store.state.isLoggedIn = false;
        next({ name: "login", params: { lastPage: from } });
        return;
      }
    } catch (err) {
      console.log(err);
      localStorage.clear();
      store.state.isLoggedIn = false;
      next({ name: "login", params: { lastPage: from } });
      return;
    }
  }

  if (
    !!localStorage.getItem("token") &&
    to.name !== "resetPassword" &&
    localStorage.getItem("mustChangePassword") === "true"
  ) {
    next({ name: "resetPassword" });
    return;
  }

  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("userType") == "SuperAdmin"
  ) {
    next({ name: "superadminDashboard" });
    return;
  }

  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") === "JewelleryAdmin"
  ) {
    next({ name: "JewelleryDashboard" });
    return;
  }
  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") === "Staff"
  ) {
    next({ name: "StaffDashboard" });
    return;
  }
// Redirection userwise
if (
  to.matched.some((route) => route.meta.isSuperAdmin == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.role == 'SuperAdmin'
) {
  next({ name: "superadminDashboard" });
  return;
}
if (
  to.matched.some((route) => route.meta.isJewellaryAdmin == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.userType == 'JewelleryAdmin'
) {
  // console.log("2");
  next({ name: "JewelleryDashboard" });
  return;
}
if (
  to.matched.some((route) => route.meta.isStaff == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.userType == 'Staff'
) {
  next({ name: "StaffDashboard" });
  return;
}


  next();
});

export default router;
